module.exports = __webpack_public_path__ + "img/01_no.3435f3d2.svg";